//
// http://gitlab.qtang.net/luolj/hbgj-api/blob/master/desc.md
//
import md5 from 'blueimp-md5'
import getCommonParams from '@/utils/getCommonRequestParams'


function generateSid(keys, obj, toUpper = true) {
  let s = keys.map(k => (obj[k])).join('')
  let e = md5(s + '&*^%@%$^#&')
  let sid = [4, 1, 16, 9, 19, 30, 28, 22].map(i => (e[i])).join('')
  return toUpper ? sid.toUpperCase() : sid
}

export default {
  getCommonParams,
  generateSid
}



// WEBPACK FOOTER //
// ./src/request/transformers/gaotie-api.js